import { useMutation } from "@apollo/client";

import { gql } from "~/__generated__";

const MAP_EDITOR_LAYER_CREATE_FROM_FILE = gql(`
    mutation MapEditorLayerCreateFromFile($input: GqlMapEditorLayerStartImportInput!) {
        mapEditorLayerCreateFromFile(input: $input) {
        id
        worker
        status
        message
        output
        }
    }
`);

export default function useMapEditorLayerCreateFromFile() {
    const [layerCreate, { data, loading, error }] = useMutation(MAP_EDITOR_LAYER_CREATE_FROM_FILE);

    return {
        layerCreate: (projectId: string, mediaId: string) =>
            layerCreate({
                variables: {
                    input: {
                        projectId,
                        mediaId,
                    },
                },
            }),
        loading,
        error,
        data: data?.mapEditorLayerCreateFromFile,
    };
}
